module.exports = __webpack_public_path__ + "img/Forget-1.610b3345.svg";